import React, { useEffect, useState } from "react";
import { getDashboardPerPeriod } from "../../services";
import { BarDashboard } from "../../components";

const PerPeriod = (props) => {
  const { startDate, endDate, filter, locationId } = props;
  const [data, setData] = useState();
  // Set all dates in array for dashboard ticks
  let ticks = [];
  if (data) {
    data.data.map((value, i) => {
      ticks.push(value["x"]);
    });
  }

  useEffect(() => {
    getDashboardPerPeriod(locationId, startDate, endDate, filter).then(
      (res) => {
        setData(res);
      }
    );
  }, [startDate, endDate, filter, locationId]);

  let format = (v) => `${parseFloat(v/1000).toFixed(2)} kg`
  if (filter == 1) format = (v) => `€${parseFloat(v).toFixed(2)}`

  if (data && ticks != []) return <BarDashboard ticks={ticks} data={data.data} format={format}/> 
  else return <div></div>
};

export default PerPeriod;
